module.exports = __webpack_public_path__ + "static/media/test9_2.44c88d84.png";